import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "mas-form-pc" }

import { getCurrentInstance, ref } from "vue";
import { FormInstance, FormRules } from "element-plus";

//添加埋点相关参数——兼容原mas-form功能
interface ItrackingEventData {
  id: string;
  trackIngCategory: string;
  trackingDesc: string;
}


const __default__ = { name: "MasFormMain" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  form: {
    type: Object as () => Record<string, any>,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  ruleForm: {
    type: Object as () => FormRules,
  },
  labelWidth: {
    type: [String, Number],
  },
  labelPosition: {
    type: String,
    default: "left",
  },
  labelSuffix: {
    type: String,
    default: ":",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  defaultFormFooter: {
    type: Boolean,
    default: true,
  },
  defaultFormFooterConfirmText: {
    type: String,
    default: "确认",
  },
  defaultFormFooterCancelText: {
    type: String,
    default: "取消",
  },
  defaultFormFooterResetText: {
    type: String,
    default: "重置",
  },
  defaultFormFooterButton: {
    type: Array as () => string[],
    default: ["confirm", "cancel", "reset"],
  },
  preventEnterSubmit: {
    type: Boolean,
    default: false
  },
  trackingInfo: {
      type: Object as () => ItrackingEventData,
    }
},
  setup(__props, { expose }) {

const props = __props

const { proxy } = getCurrentInstance() as any;
const ruleFormRef = ref<FormInstance>();


const _confimForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl?.validate((valid, fields) => {
    if (valid) {
      proxy.$emit("confim", props.form);
    } else {
      console.log("error submit!", fields);
    }
  });
};

const _enterConfirmForm = async (formEl: FormInstance | undefined) => {
  if (props.preventEnterSubmit) return;
  _confimForm(formEl);
};

const _cancelForm = (formEl: FormInstance | undefined) => {
  proxy.$emit("cancel");
  _resetForm(formEl);
};

const _resetForm = (formEl: FormInstance | undefined) => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
  proxy.$emit("reset");
};

const confirm = () => {
  _confimForm(ruleFormRef.value)
}

const cancel = () => {
  _cancelForm(ruleFormRef.value)
}

expose({
  _cancelForm,
  _resetForm,
  confirm,
  cancel
});

return (_ctx: any,_cache: any) => {
  const _component_mas_button = _resolveComponent("mas-button")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: __props.form,
      rules: __props.ruleForm,
      "label-width": __props.labelWidth,
      "label-position": __props.labelPosition,
      "label-suffix": __props.labelSuffix,
      disabled: __props.disabled,
      inline: __props.inline,
      class: _normalizeClass(__props.inline ? '' : 'mas-form-pc-center'),
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_enterConfirmForm(ruleFormRef.value)), ["enter","native"]))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "content", { content: __props.form }),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(["el-form-item-footer", { inline: __props.inline}])
        }, {
          default: _withCtx(() => [
            (__props.defaultFormFooter)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.defaultFormFooterButton.includes('confirm'))
                    ? (_openBlock(), _createBlock(_component_mas_button, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_confimForm(ruleFormRef.value))),
                        type: "primary",
                        id: __props.trackingInfo?.id,
                        trackIngCategory: __props.trackingInfo?.trackIngCategory,
                        trackingDesc: __props.trackingInfo?.trackingDesc
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.defaultFormFooterConfirmText), 1)
                        ]),
                        _: 1
                      }, 8, ["id", "trackIngCategory", "trackingDesc"]))
                    : _createCommentVNode("", true),
                  (__props.defaultFormFooterButton.includes('cancel'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_cancelForm(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.defaultFormFooterCancelText), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.defaultFormFooterButton.includes('reset'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_resetForm(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.defaultFormFooterResetText), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "footer")
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["model", "rules", "label-width", "label-position", "label-suffix", "disabled", "inline", "class"])
  ]))
}
}

})